// Same underline-and-badge tab bar the Notifications screen uses, so the admin
// has one tab pattern rather than two.
const Tab = ({ active, label, count, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-current={active ? "page" : undefined}
    className={`-mb-px inline-flex items-center gap-2 border-b-2 px-4 py-2 text-sm font-semibold transition-colors ${
      active
        ? "border-primary text-primary_dark"
        : "border-transparent text-gray-400 hover:text-secondary"
    }`}
  >
    {label}
    <span
      className={`inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-bold ${
        active ? "bg-primary text-white" : "bg-gray-200 text-gray-500"
      }`}
    >
      {count}
    </span>
  </button>
);

// `tabs` is a [{ key, label, count }] list rather than fixed props, so a new
// tab is a constant rather than another prop pair threaded through the page.
const UpcomingTabs = ({ tab, onChange, tabs }) => (
  <div className="mb-5 flex gap-1 border-b border-gray-200">
    {tabs.map(({ key, label, count }) => (
      <Tab
        key={key}
        active={tab === key}
        label={label}
        count={count}
        onClick={() => onChange(key)}
      />
    ))}
  </div>
);

export default UpcomingTabs;
